import { IAppConfig } from "./IAppConfig.intf";


export const mainModel = {
    /** 当前加载的应用配置 */
    appConfig: {} as IAppConfig,
}